module.exports = __webpack_public_path__ + "assets/img/driver-btn-ebf1318f.png";